const fetching = state => state.fetching;
const uri = state => state.uri;
const error = state => state.error;

export default {
  fetching,
  uri,
  error
}
